import { Search, MapPin, BarChart2, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const steps = [
  {
    icon: Search,
    title: "Busca",
    description:
      "Escribe el producto. Leche, huevos, zapatos, repuestos, lo que necesites en el momento.",
    color: "text-blue-500",
    bg: "bg-blue-100 dark:bg-blue-900/30",
  },
  {
    icon: BarChart2,
    title: "Compara",
    description:
      "Ve los precios actualizados, el stock disponible y exactamente qué tan cerca está de ti.",
    color: "text-orange-500",
    bg: "bg-orange-100 dark:bg-orange-900/30",
  },
  {
    icon: MapPin,
    title: "Ve directo",
    description:
      "Elige el mejor. Llega a la tienda sabiendo que sí hay disponibilidad y cuánto cuesta.",
    color: "text-green-500",
    bg: "bg-green-100 dark:bg-green-900/30",
  },
];

export default function HowItWorks() {
  return (
    <section className="py-16 sm:py-24 bg-white dark:bg-slate-900/50">
      <div className="container px-4 mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-100 text-blue-600 text-xs font-bold mb-4"
          >
            <Sparkles className="w-3 h-3" />
            PROCESO SIMPLIFICADO
          </motion.div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6 font-display tracking-tight">
            En 3 pasos, sin complicaciones
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto relative">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[2px] bg-slate-100 dark:bg-slate-800 -z-10" />

          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.15 }}
              viewport={{ once: true }}
              className="relative p-6 sm:p-8 rounded-2xl sm:rounded-3xl bg-slate-50 dark:bg-slate-800/80 border border-slate-100 dark:border-slate-700 text-center hover:shadow-xl hover:shadow-primary/5 transition-all group"
            >
              <div className="absolute -top-3 -left-3 sm:-top-4 sm:-left-4 w-6 h-6 sm:w-8 sm:h-8 rounded-full bg-white dark:bg-slate-700 border-2 border-slate-100 dark:border-slate-600 flex items-center justify-center text-xs sm:text-sm font-bold text-slate-400">
                {index + 1}
              </div>

              <div
                className={`w-16 h-16 sm:w-20 sm:h-20 mx-auto rounded-xl sm:rounded-2xl ${step.bg} ${step.color} flex items-center justify-center mb-4 sm:mb-6 shadow-inner group-hover:scale-110 transition-transform`}
              >
                <step.icon className="w-8 h-8 sm:w-10 sm:h-10" />
              </div>

              <h3 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-white mb-3 sm:mb-4">
                {step.title}
              </h3>

              <p className="text-sm sm:text-base text-slate-600 dark:text-slate-400 leading-relaxed font-medium">
                {step.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
